import React, { useState } from 'react';

const PoissonCumulativeTable = () => {
  const [lambda, setLambda] = useState(1);
  const [maxX, setMaxX] = useState(10);
  const [poissonTable, setPoissonTable] = useState([]);

  // Function to calculate Poisson probability for a given x and lambda
  const poissonProbability = (x, lambda) => {
    return (Math.pow(lambda, x) * Math.exp(-lambda)) / factorial(x);
  };

  // Function to calculate factorial of a number
  const factorial = (n) => {
    if (n === 0 || n === 1) return 1;
    return n * factorial(n - 1);
  };

  // Function to generate the cumulative Poisson table
  const generatePoissonTable = () => {
    if (lambda <= 0 || maxX <= 0) {
      alert("Please enter valid values for lambda and maxX (both should be greater than 0).");
      return;
    }

    let cumulativeProbability = 0;
    const table = [];
    for (let x = 0; x <= maxX; x++) {
      cumulativeProbability += poissonProbability(x, lambda);
      table.push({
        x,
        cumulativeProbability: cumulativeProbability.toFixed(4),
      });
    }
    setPoissonTable(table);
  };

  return (
    <div>
      <h2>Cumulative Poisson Distribution Table</h2>
      <label htmlFor="lambda">Lambda (λ): </label>
      <input
        type="number"
        id="lambda"
        value={lambda}
        min="0.1"
        step="0.1"
        onChange={(e) => setLambda(parseFloat(e.target.value))}
      />
      <br />
      <label htmlFor="maxX">Max X Value: </label>
      <input
        type="number"
        id="maxX"
        value={maxX}
        min="1"
        onChange={(e) => setMaxX(parseInt(e.target.value))}
      />
      <br />
      <button onClick={generatePoissonTable}>Generate Table</button>

      {poissonTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>X</th>
              <th>Cumulative Probability</th>
            </tr>
          </thead>
          <tbody>
            {poissonTable.map((row, index) => (
              <tr key={index}>
                <td>{row.x}</td>
                <td>{row.cumulativeProbability}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PoissonCumulativeTable;
